module.exports = false;



//////////////////
// WEBPACK FOOTER
// C:/Users/admin/Documents/Visual Studio 2017/Projects/VanzAngularEcommerce/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 0